const GoogleMapsLoader = require('google-maps');
const { googleAddressComponentsToAddressData } = require('@/lib/Addresses/addressFunctions');

/**
 * @param $timeout
 * @param {CountryManager} countryManager
 * @param {UserService} userService
 */
const addressFormDirective = function (
    $timeout,
    countryManager,
    userService,
) {
    return {
        scope: {
            address: '=',
            // This needs to be readOnly instead of readonly because the latter gets interpreted as an
            // HTML attribute instead of a prop.
            readOnly: '=',
        },
        restrict: 'E',
        replace: true,
        templateUrl: 'partials/directives/dt-address-form.html',
        link(
            $scope,
            element,
        ) {
            $scope.searchDisabled = !!$scope.readOnly;

            $timeout(() => {
                let $element = $(element); // jQuery
                $scope.addressElements = {
                    addressSearch: $element.find('.address-form__input--search'),
                    houseNumber: $element.find('.address-form__input--house-number'),
                };

                $scope.countries = countryManager.getCountries();

                const addPlaceEventListener = (autoCompleteInstance, google) => {
                    // Place change is fired when an address from the autocomplete is selected
                    google.maps.event.addListener(autoCompleteInstance, 'place_changed', function () {
                        $timeout(() => {
                            const place = autoCompleteInstance.getPlace();
                            // console.log('place_changed', place);
                            if (!place || !place.address_components) {
                                return;
                            }

                            // Fill the Address model with the address data converted
                            // from the Google Places address components.
                            const addressData = googleAddressComponentsToAddressData(place.address_components);
                            Object.keys(addressData).forEach((key) => {
                                $scope.address[key] = addressData[key];
                            });
                            // Ensure the 'country' in the address is a Country object not just a string.
                            $scope.address.country = countryManager.findByData({ country: $scope.address.country });

                            // Clear the search box.
                            $scope.addressElements.addressSearch.val('');
                            $scope.addressElements.houseNumber.focus();
                        });
                    });
                };

                /**
                 * Options to control and filter the results of the Autocomplete
                 *
                 * By default the Autocomplete.getPlace() will return results from multiple APIs and return things
                 * like ratings, reviews, opening hours, and phone numbers which are all chargeable
                 *
                 * We can exclude unnecessary data and limit costs by using the 'fields' option and reinforcing this
                 * with the 'types' option (which also improves search quality by excluding businesses)
                 *
                 * By excluding unwanted data the free $200 credit should provide 11000 searches / month vs 8000
                 *
                 * @see https://developers.google.com/places/web-service/autocomplete#place_types
                 * @see https://developers.google.com/places/web-service/details#fields
                 * @see https://cloud.google.com/maps-platform/pricing/sheet/
                 *
                 * @param {string} country
                 */
                const getGoogleAutocompleteOptions = (country) => {
                    let options = {};

                    // type: address will only search a full address e.g. 6 some street etc.
                    // type: geocode is required to search by postcode and also excludes things like businesses
                    options.types = ['geocode'];

                    // we should only need fields from the 'Basic' category
                    options.fields = [
                        'address_component',
                        // 'formatted_address',
                        // 'geometry',
                    ];

                    if (country) {
                        options.componentRestrictions = {
                            country,
                        };
                    }

                    return options;
                };

                if (userService.company.googleCloudApiKey) {
                    $timeout(() => {
                        GoogleMapsLoader.VERSION = '3.57';
                        GoogleMapsLoader.LIBRARIES = ['places'];
                        GoogleMapsLoader.KEY = userService.company.googleCloudApiKey;
                        GoogleMapsLoader.load(function (google) {
                            let countryCode = $scope.address && $scope.address.country && $scope.address.country.code ? $scope.address.country.code : null;
                            let autoComplete = new google.maps.places.Autocomplete(
                                $scope.addressElements.addressSearch[0],
                                getGoogleAutocompleteOptions(countryCode),
                            );

                            addPlaceEventListener(autoComplete, google);

                            $scope.$watch('address.country', function handleWatchChange(newCountry) {
                                if (!newCountry || countryCode === newCountry.code) {
                                    return;
                                }

                                google.maps.event.clearListeners(autoComplete, 'place_changed');
                                countryCode = newCountry.code;
                                autoComplete = new google.maps.places.Autocomplete(
                                    $scope.addressElements.addressSearch[0],
                                    getGoogleAutocompleteOptions(countryCode),
                                );

                                addPlaceEventListener(autoComplete, google);
                            });
                        });
                    }, 1);
                } else {
                    $scope.searchDisabled = true;
                }
            }, 1);
        },

        controller($scope) {
            $scope.clearAddress = ($event) => {
                $event.preventDefault();
                $event.stopPropagation();

                $scope.address.clear();

                if ($scope.$parent.useCustomerAddress !== undefined) {
                    $scope.$parent.useCustomerAddress = false;
                    $scope.$parent.selectedDeliveryAddressKey = null;
                }

                if ($scope.addressElements) {
                    $scope.addressElements.addressSearch.val('').focus();
                }
            };
        },
    };
};

module.exports = addressFormDirective;
